import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";

import { Link } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { formatNumber } from "@/features/shared";

// Rendered inside the detail page's tab panel, which already names it — no
// heading of its own.
export const DownPaymentAllocationsSection = ({
  purchaseDownPaymentAllocations,
}) => {
  const columns = [
    {
      field: "referenceNumber",
      headerName: "No. Faktur",
      flex: 2,
      valueGetter: (_, row) =>
        row.sourceReferenceNumber ?? row.sourcePurchaseInvoice?.referenceNumber,
      renderCell: ({ value }) =>
        value ? (
          <Link
            component={RouterLink}
            to={`/procurement/purchase-down-payments/${value}`}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            {value}
          </Link>
        ) : (
          "-"
        ),
    },
    {
      field: "amount",
      headerName: "Nominal",
      flex: 1,
      type: "number",
      valueFormatter: (value) => formatNumber(value || 0),
    },
    {
      field: "note",
      headerName: "Catatan",
      flex: 2,
      valueGetter: (_, row) =>
        row.note ?? row.sourcePurchaseInvoice?.note ?? "-",
    },
  ];

  return (
    <DataGrid
      columns={columns}
      rows={purchaseDownPaymentAllocations || []}
      disableRowSelectionOnClick
      hideFooter
    />
  );
};

DownPaymentAllocationsSection.propTypes = {
  purchaseDownPaymentAllocations: PropTypes.array,
};
